interface UseUploadFilesOptions {
	acceptedFileTypes: string[];
	singleFile?: boolean;
	onFilesUploaded?: (files: File[]) => Promise<void>;
	onError: () => void;
}

interface UseUploadFiles {
	acceptedFileTypes: string[];
	singleFile?: boolean;
	onDrop: (event: React.DragEvent<HTMLDivElement> | React.ChangeEvent<HTMLInputElement>) => void;
}

export const useUploadFiles = ({
	acceptedFileTypes,
	singleFile = false,
	onFilesUploaded,
	onError,
}: UseUploadFilesOptions): UseUploadFiles => {
	const handleFileDrop = async (
		event: React.DragEvent<HTMLDivElement> | React.ChangeEvent<HTMLInputElement>
	) => {
		event.preventDefault();

		let files: File[] = [];

		if ('dataTransfer' in event) {
			// For the drag event
			files = Array.from(event.dataTransfer.files);
		} else if ('target' in event && event.target.files) {
			// For the file input
			files = Array.from(event.target.files);
		}

		if (onFilesUploaded) {
			try {
				await onFilesUploaded(files);
			} catch {
				if (onError) {
					onError();
				}
			}
		}
	};

	return {
		acceptedFileTypes,
		singleFile,
		onDrop: handleFileDrop,
	};
};
